import firebase from 'firebase/app';

export default {
  namespaced: true,
  state: {
    user: null,
    status: null,
    idToken: null,
  },

  getters: {
    user: state => state.user,
    token: state => state.idToken,
    displayName: state => (state.user ? state.user.displayName : ''),
    photoURL: state => (state.user ? state.user.photoURL : null),
    email: state => (state.user ? state.user.email : 'email@domain.com'),
    emailVerified: state => (state.user ? state.user.emailVerified : false),
    isAuthenticated: state => !!state.user,
  },

  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setIdToken(state, token) {
      state.idToken = token;
    },
  },

  actions: {
    signIn({ commit }, payload) {
      return new Promise((resolve, reject) => {
        firebase.auth()
          .signInWithEmailAndPassword(payload.email, payload.password)
          .then((response) => {
            // console.log(response.user);
            const {
              uid, displayName, photoURL, email, emailVerified, phoneNumber,
            } = response.user;
            commit('setUser', {
              uid, displayName, photoURL, email, emailVerified, phoneNumber,
            });
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    resetPassword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const { email } = payload;

        firebase.auth().sendPasswordResetEmail(email)
          .then(() => {
            commit('setStatus', 'success');
            resolve();
          })
          .catch((error) => {
            commit('setStatus', 'failure');
            reject(error);
          });
      });
    },
    signOut({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          firebase.auth().signOut().then(() => {
            commit('setUser', null);
            commit('setIdToken', null);
            window.localStorage.clear();
            resolve();
          }).catch(() => {
            commit('setUser', null);
            commit('setIdToken', null);
            window.localStorage.clear();
            reject();
          });
        } catch (error) {
          // console.log(`Signout error ${error}`);
          commit('setUser', null);
          commit('setIdToken', null);
          window.localStorage.clear();
        }
      });
    },
    getIdToken({ commit }) {
      return new Promise((resolve, reject) => {
        const currentUser = firebase.auth().currentUser;
       
        if (currentUser !== null) {
          currentUser.getIdToken(true)
            .then((idToken) => {
              commit('setIdToken', idToken);
              commit('setStatus', 'success');
              resolve(idToken);
            })
            .catch((error) => {
              commit('setIdToken', null);
              commit('setStatus', 'failure');
              reject(error);
            });
        } else {
          
          commit('setUser', null);
          commit('setIdToken', null);
          reject("current user is null");
        }

      });
    },
  },
};
